import BudgetsRoutes from "../../../components/budgetsV2/budgetRoutes";

const BudgetsV2Page = (props: any) => {
  return <BudgetsRoutes {...props} persona="fleet-manager" />;
};

export default BudgetsV2Page;
